module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "IMG_0012.1bea9c91.jpg" + "?" + Date.now();